module.exports = "/static/js/00bba9d67262d95c7f87b84a852c069d.png";